import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';

const LabAssignmentsDashboard = () => {
  const [labDays, setLabDays] = useState([]);
  const navigate = useNavigate();

  const fetchLabs = async () => {
    const labsCollectionRef = collection(db, 'labs');
    const data = await getDocs(labsCollectionRef);
    setLabDays(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => {
    fetchLabs();
  }, []);

  const handleDelete = async (labId) => {
    if (window.confirm("Are you sure you want to delete this lab?")) {
      try {
        await deleteDoc(doc(db, "labs", labId));
        fetchLabs(); // Refresh the list after deletion
      } catch (error) {
        console.error("Error removing document: ", error);
        alert("Failed to delete lab: " + error.message);
      }
    }
  };

  return (
    <div className="min-h-screen bg-bg text-text p-6">
      <h1 className="text-2xl font-bold mb-6 text-primary">Lab Assignment Dashboard</h1>
      <button
        className="mb-4 bg-primary text-white px-4 py-2 rounded shadow hover:bg-secondary hover:text-primary font-semibold transition duration-200"
        onClick={() => navigate('/lab-assignments/new')}
      >
        + New Lab Day
      </button>
      
      <div className="mt-6">
        {labDays.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {labDays.map(lab => (
              <div key={lab.id} className="p-4 border rounded-xl bg-table shadow">
                <h2 className="text-lg font-bold">{lab.labTitle ? lab.labTitle : lab.className}</h2>
                <p>
                  {lab.labDate
                    ? new Date(lab.labDate).toLocaleDateString()
                    : (lab.createdAt && lab.createdAt.seconds
                        ? new Date(lab.createdAt.seconds * 1000).toLocaleDateString()
                        : '')}
                </p>
                <div className="mt-4 flex gap-2">
                  <button onClick={() => navigate(`/lab-assignments/edit/${lab.id}`)} className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-700">Edit</button>
                  <button onClick={() => handleDelete(lab.id)} className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-700">Delete</button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-text/70">No lab days created yet.</div>
        )}
      </div>

      <button
        className="mt-8 bg-secondary text-primary px-4 py-2 rounded shadow hover:bg-primary hover:text-white font-semibold transition duration-200"
        onClick={() => navigate('/admin')}
      >
        Back to Admin Dashboard
      </button>
    </div>
  );
};

export default LabAssignmentsDashboard;
